export const useSxStyles = () => {
  return {
    tooltipContainer: {
      display: 'inline-flex',
      overflow: 'hidden',
      '& a': {
        fontSize: 'inherit',
      },
    },
  };
};
